
import React, { useEffect } from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import "./../../styles/setting.css";
import { objectToFormData, findLodash } from '../../../../utils';
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { updateUserFields, addUserFields, GetUserFields } from '../../../../actions/companySettings';
import { Input, Form, Checkbox, Button, Row, Col, Select } from 'antd';
import { useFormik } from 'formik';

const { Option } = Select;

const ValidationSchema = yup.object().shape({
  column_name: yup
    .string()
    .required('Please provide category name'),
  column_type: yup.string().required("Please provide column type"),
  default_values: yup.mixed().when("column_type", {
    is: "dropdown",
    then: yup.array().of(yup.object().shape({
      // id: yup.string().required(),
      level: yup.string().required()
    })).required().min(1),
    otherwise: yup.array()
  })
});

const AddCustomField = (props) => {
  const { id: currentId } = props;
  const formik = useFormik({
    initialValues: {
      column_name: "",
      column_type: "",
      default_values: [{ id: 1, level: '' }],
      is_required: false,
      view_in_pdf: false,
      is_enable: false,
    },
    validationSchema: ValidationSchema,
    onSubmit: (payload) => {
      Object.keys(payload).forEach(key => {
        if (!payload[key] && typeof payload[key] !== "boolean") {
          delete payload[key];
        }
      });
      const default_values = fieldsData.map(item => item.level);

      if (selectedDataType === 'dropdown') {
        payload.default_values = [...default_values];
      } else {
        delete payload.default_values
      }
      currentId ?
        dispatch(updateUserFields(objectToFormData({ ...payload, id: currentId.toString() }))) :
        dispatch(addUserFields(objectToFormData({ ...payload })));
    }
  })
  const dispatch = useDispatch();
  const [fieldsData, setFieldsData] = React.useState([{ id: 1, level: '' }]);
  const [selectedDataType, setSelectedDataType] = React.useState('');
  const getUserFieldsResponse = useSelector(state => state.companySetting.getUserFields || {});

  React.useEffect(() => {
    formik.resetForm();
    if (getUserFieldsResponse.success && currentId) {
      const editValues = findLodash(getUserFieldsResponse.data.response.fields, { id: currentId });
      formik.setValues({
        column_name: editValues.column_name,
        column_type: editValues.column_type,
        is_required: editValues.is_required,
        view_in_pdf: editValues.view_in_pdf,
        is_enable: editValues.is_enable,
        default_values: Array.isArray(editValues.default_values) ? editValues.default_values.map((item, idx) => ({ id: idx + 1, level: item })) : [{ id: 1, level: '' }]
      });
      setSelectedDataType(editValues.column_type);
      if (editValues && Array.isArray(editValues.default_values)) {
        const arr = editValues.default_values.map((item, idx) => ({ id: idx + 1, level: item }))
        setFieldsData(arr.length ? arr : [{ id: 1, level: '' }])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const handleCancelButton = () => {
    formik.resetForm();
    setSelectedDataType("")
    props.handleCancel();
    // dispatch({
    //   type: GetUserFields.RESET
    // })
  }

  useEffect(() => {
    return () => {
      handleCancelButton()
    }
  }, [])

  const handleFields = (type, key) => {
    if (type === 'add') {
      setFieldsData([...fieldsData, { id: fieldsData.length + 1, level: '' }]);
      formik.setFieldValue("default_values", [...fieldsData, { id: fieldsData.length + 1, level: '' }])

    } else {

      const filterArray = [...fieldsData];
      filterArray.splice(key, 1)
      setFieldsData([...filterArray]);
      formik.setFieldValue("default_values", filterArray)

    }
  }

  const handleInputs = (evt, key) => {
    fieldsData[key].level = evt.target.value;
    setFieldsData([...fieldsData]);
    formik.setFieldValue("default_values", fieldsData)
  }

  return (
    <>
      <Form
        layout="vertical"
        onFinish={formik.handleSubmit}
        className="modal-form custom-form"
      >
        <div
          className="nameItem">
          <label className={`inline-block required`}>{"Custom name"}</label><br />

          <Input placeholder="Custom name"
            maxLength={50}
            onChange={formik.handleChange} name="column_name"
            value={formik.values.column_name}
          />
          {formik.touched.column_name && formik.errors.column_name && <div className='errorMsg'>
            {formik.errors.column_name}
          </div>}
        </div>
        <div
          className="nameItem">
          <label className={`inline-block required`}>{"Column Type"}</label><br />
          <Select
            placeholder="Select Column Type"
            className='w100'
            value={formik.values.column_type}
            onChange={(val) => {
              setSelectedDataType(val)
              formik.setFieldValue("column_type", val)
            }}
          >
            <Option value="string">Text Box (Single Line)</Option>
            <Option value="integer">Number (123..)</Option>
            <Option value="dropdown">Dropdown</Option>
            {/* <Option value="checkbox">Check Box</Option>
                  <Option value="multicheckbox">Multi Select</Option> */}
          </Select>
          {formik.touched.column_type && formik.errors.column_type && <div className='errorMsg'>
            {formik.errors.column_type}
          </div>}
        </div>
        {selectedDataType === 'dropdown' ?
          <Form.Item label="Default Value">
            <div className='optionsContainer'>
              <Row>
                {formik.values.default_values.map((item, index) =>
                  <div key={item.id} className='fieldsDiv mt1'>
                    <span className='inlineItem levelTitle'>Options {index + 1}</span>
                    <Input className='inlineItem' onChange={(e) => handleInputs(e, index)} value={item.level} />
                    <MinusCircleOutlined className='minusButton inlineItem mtHalf cursor ml2' onClick={() => handleFields('remove', index)} />
                  </div>)}
              </Row>
              <Button type="link" className='addFieldButton mt2' onClick={() => handleFields('add')}>
                <PlusCircleOutlined /> ADD OPTION
              </Button>
              {formik.touched.default_values && formik.errors.default_values?.length && <div className='errorMsg'>
                Options are required
              </div>}
            </div>
          </Form.Item> : null}
        <Row>
          <Col span={24}>
            <Form.Item>
              <Checkbox name="is_required" checked={formik.values.is_required} onChange={formik.handleChange}>Is Mandatory</Checkbox>
            </Form.Item>
          </Col>
          {/* <Col span={24}>
            <Form.Item >
              <Checkbox name="view_in_pdf" checked={formik.values.view_in_pdf} onChange={formik.handleChange}>Show in all PDF</Checkbox>
            </Form.Item>
          </Col> */}
          {currentId &&
            <Col span={24}>
              <Form.Item >
                <Checkbox name="is_enable" checked={formik.values.is_enable} onChange={formik.handleChange}>Enable</Checkbox>
              </Form.Item>
            </Col>}
        </Row>

        <Button key="1" htmlType="submit" className="formButton mt1 primaryButton">{currentId ? 'Update' : 'Save'}</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    </>
  );
}

export default AddCustomField;

